<template>
  <form name="contato" method="post" data-netlify="true" data-netlify-honeypot="bot-field">
    <input type="hidden" name="form-name" value="contato" />
    <h1>vamos bater um papo?</h1>
    <label for="nome">Nome</label>
    <input type="text" name="nome" id="nome" />
    <label for="telefone">Telefone</label>
    <input type="text" name="telefone" id="telefone" />
    <label for="email">Email</label>
    <input type="email" name="email" id="email" />
    <label for="mensagem">Mensagem</label>
    <textarea name="mensagem" cols="30" rows="10"></textarea>
    <button type="submit">enviar mensagem</button>
  </form>
</template>

<script>
export default {
  name: "FormContato",
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
form {
  box-sizing: border-box;
  // border: 3px solid $verde-exception;
  box-shadow: 3px 3px 5px rgba($color: #000000, $alpha: 0.3);
  padding: 20px;
  border-radius: 10px;
  width: 300px;
  background: $verde-exception;
  @include flexbox(column, center, center);
  @include for-phone-only {
    width: 90vw;
  }
  @include for-tablet-portraid-up {
    width: 40vw;
  }
  @include for-tablet-landscape-up {
    width: 30vw;
  }
}

h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  @include for-tablet-portraid-up {
    font-size: 1.5rem;
  }
}
label {
  color: #fff;
  width: 100%;
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  align-self: flex-start;
}

input,
textarea {
  box-sizing: border-box;
  height: 50px;
  width: 100%;
  background: $verde-exception;
  border: solid 3px #fff;
  background: none;
  border-radius: 5px;
  margin-bottom: 20px;
  color: white;
  padding: 10px;
  font-size: 1rem;
  font-family: $fonte-primaria;
  font-weight: 500;
  transition: all 0.2s;
}

input:focus,
textarea:focus {
  transform: scale(1.02);
  outline: none;
  background: $verde-exception;
}

textarea {
  height: 100px;
}

button {
  display: block;
  width: 90%;
  border: none;
  color: $cor-primaria;
  background: #fff;
  padding: 20px 20px;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 1rem;
  cursor: pointer;

  transition: all 0.2s;
  &:hover {
    transform: scale(1.05);
  }
}
</style>